import React from 'react';
import { useMusicTranslations } from '../../utils/translations';

interface MusicianFieldsProps {
  genres: string[];
  skills: string[];
  onGenreChange: (genre: string) => void;
  onSkillChange: (skill: string) => void;
}

export function MusicianFields({
  genres,
  skills,
  onGenreChange,
  onSkillChange,
}: MusicianFieldsProps) {
  const { getTranslatedGenres, getTranslatedSkills } = useMusicTranslations();
  
  const translatedGenres = getTranslatedGenres();
  const translatedSkills = getTranslatedSkills();

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-light/80 mb-4">
          What genres do you play?
        </label>
        <div className="grid grid-cols-3 gap-4">
          {translatedGenres.map((genre) => (
            <label key={genre.value} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={genres.includes(genre.value)}
                onChange={() => onGenreChange(genre.value)}
                className="h-4 w-4 rounded border-gray-custom/20 text-primary focus:ring-primary"
              />
              <span className="text-light/80">{genre.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-light/80 mb-4">
          What are your musical skills?
        </label>
        <div className="grid grid-cols-3 gap-4">
          {translatedSkills.map((skill) => (
            <label key={skill.value} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={skills.includes(skill.value)}
                onChange={() => onSkillChange(skill.value)}
                className="h-4 w-4 rounded border-gray-custom/20 text-primary focus:ring-primary"
              />
              <span className="text-light/80">{skill.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}